import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { faCircleInfo, faDownload } from "@fortawesome/free-solid-svg-icons";
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { Title } from "@angular/platform-browser";
import { ReportsColumnsComponent } from './reports-columns/reports-columns.component';
import { MatDialog } from '@angular/material/dialog'
import { DialogService } from 'src/app/services/dialog.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { DynamicReportService } from 'src/app/services/dynamic-report.service';


@Component({
  selector: 'app-reports',
  standalone: false,
  templateUrl: './reports.component.html',
  styleUrl: './reports.component.scss'
})
export class ReportsComponent implements AfterViewInit {
  protected readonly faCircleInfo = faCircleInfo;
  protected readonly faCircleXmark = faCircleXmark;
  protected readonly faDownload = faDownload;

  showInfo: boolean = true;
  selectedColumns: any;
  recordList: any[] = [];
  displayedColumns: any[] = [];
  report_data: any;

  @ViewChild(MatSort) sort = {} as MatSort;
  @ViewChild(MatPaginator) paginator = {} as MatPaginator;
  dataSource = new MatTableDataSource();

  constructor(
    private readonly titleService: Title,
    public dialog: MatDialog,
    private readonly dialogService: DialogService,
    private readonly dynamicReportService: DynamicReportService,
  ) {
    titleService.setTitle('BAER - Reports')
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  setColumns() {
    this.dialogService.openSpinner();
    this.dialogService.closeSpinner();

    this.dialog.open(ReportsColumnsComponent, {
      maxWidth: "750px",
      minWidth: "750px",
      height: "100%",
      autoFocus: false,
      position: { right: '0px', top: '0px', bottom: '0px' },
      panelClass: ['animate__animated', 'animate__fadeInRight'],
      data: {
        selectedColumns: this.selectedColumns
      },
    }).afterClosed().subscribe((selectedColumns) => {
      if (selectedColumns) {
        this.selectedColumns = selectedColumns;
        this.dataSource.data = []; //reset for new filter options
      }
    })
  }

  runReport(filters: string) {
    this.recordList = this.selectedColumns.map((record: any) => { return record.column });
    this.dialogService.openSpinner();
    this.displayedColumns = this.recordList;
    let recordList = this.recordList.toString();
    this.dynamicReportService.getDynamicReport(recordList, filters).subscribe((data: any) => {
      this.dataSource.data = data.dynamicReports;
      this.dialogService.closeSpinner();
    });
  }

  removeCol(column: any) {
    const copy = [...this.selectedColumns];
    copy.splice(this.selectedColumns.indexOf(column), 1);
    this.selectedColumns = copy;
  }

  exportToCsv() {
    this.dialogService.openSpinner();
    if (!this.dataSource.data?.length) {
      let recordList = this.recordList.toString();
      this.dynamicReportService.getDynamicReport(recordList, '').subscribe((data: any) => {
        this.generateCsv(data.dynamicReports);
        this.dialogService.closeSpinner();
      });
    } else {
      this.generateCsv(this.dataSource.data);
      this.dialogService.closeSpinner();
    }
  }

  generateCsv(rows: any[]) {
    if (!rows.length) {
      return;
    }

    const header = (this.selectedColumns as { column: string; name: string }[]).map((v) => v.name as string);

    const lines: string[] = [];
    lines.push(header.map(h => this.csvEscape(h)).join(','));

    for (const row of rows) {
      const lineValues = this.selectedColumns.map((v: any) => row[v.column] ?? '--');
      lines.push(lineValues.map((v: any) => this.csvEscape(v)).join(','));
    }

    const csvContent = lines.join('\r\n');
    const blob = new Blob([csvContent], {
      type: 'text/csv;charset=utf-8;',
    });

    const url = globalThis.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `baer-custom-reports-${new Date()
      .toISOString()
      .slice(0, 10)}.csv`;

    a.click();
    globalThis.URL.revokeObjectURL(url);
  }

  private csvEscape(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }

    const str = String(value);

    if (/[",\r\n]/.test(str)) {
      return `"${str.replaceAll('"', '""')}"`;
    }

    return str;
  }

}
